import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
import VCCalculator_FY25_03 from '../fy25_03';

// NOTE: `next` to be renamed `fy26.04` once stable
var REVISION_NO = 'next';
var getConsideredEntryTypes = function getConsideredEntryTypes() {
  return ['mutation:display-contents-children-element'];
};

// NOTE: `VCNext` to be renamed `FY26_04` once stable
var VCNextCalculator = /*#__PURE__*/function (_VCCalculator_FY25_) {
  function VCNextCalculator() {
    _classCallCheck(this, VCNextCalculator);
    return _callSuper(this, VCNextCalculator, [REVISION_NO]);
  }
  _inherits(VCNextCalculator, _VCCalculator_FY25_);
  return _createClass(VCNextCalculator, [{
    key: "isEntryIncluded",
    value: function isEntryIncluded(entry, include3p) {
      var isEntryIncludedInV3 = _superPropGet(VCNextCalculator, "isEntryIncluded", this, 3)([entry, include3p]);
      if (isEntryIncludedInV3) {
        return true;
      }
      return getConsideredEntryTypes().includes(entry.data.type);
    }
  }]);
}(VCCalculator_FY25_03);
export { VCNextCalculator as default };